import { ref } from 'vue'
import store from '@/store';

function fixImageUrls(html) {
  const baseUrl = 'https://dashboard.imslearn.org';
  return html.replace(/src="(\.\.\/\.\.\/\.\.\/storage\/[^"]+)"/g, (match, relativePath) => {
    return `src="${baseUrl}/${relativePath.replace(/^\.\.\/+/, '')}"`;
  });
}
const GetMobileApp = () => {

  const loadedData = ref([])
  const data_error = ref(null)

  const loadData = async () => {
    try {
      let data = await fetch('https://dashboard.imslearn.org/api/data/mobile_app')
      if (!data.ok) {
        throw Error('no available courses')
      }
      await data.json().then((res) => {
        if (res.success) {
          res.data = res.data.map(item => ({
            ...item,
            text: fixImageUrls(item.text)
          }));
          loadedData.value = res.data
          store.commit('setMobileApp', res.data);
        } else {
          console.log('unable to load mobile data')
          console.log(res) // todo check with zeina what where is the error message in response res.error ?
        }
      })
    }
    catch (err) {
      data_error.value = err.message
    }
  }

  return { loadedData, data_error, loadData }
}

export default GetMobileApp